<template>
	<section id="wrapper" class="error-page">
        <div class="error-box">
            <div class="error-body text-center">
                <h1>404</h1>
                <h3 class="text-uppercase">{{'components/error/page-not-found.oops' | trans}}</h3>
                <p class="text-muted m-t-30 m-b-30">{{'components/error/page-not-found.page-not-exist' | trans}}</p>
                <router-link to="/" class="btn backToHome">{{'components/error/page-not-found.back-to-home' | trans}}</router-link>
			</div>
        </div>
    </section>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>

<style scoped>
    .backToHome {
        margin-top: 10px;
    }
</style>
